<svelte:options customElement={{ tag: "app-admin", shadow: "none" }} />

<script>
  import { fly } from "svelte/transition";
  import { onMount } from "svelte";

  // Components
  import Dashboard from "./admin/Dashboard.svelte";
  import Reset from "./admin/Reset2FA.svelte";
  import Session from "./admin/SessionRules.svelte";
  import { ActiveTab } from "../stores/AdminStore.ts";
  import { toasts } from "../stores/ToastStore.ts";
  import AclApps from "./admin/Acl/Apps.svelte";
  import AclNewApp from "./admin/Acl/NewApp.svelte";
  import AclScopes from "./admin/Acl/Scopes.svelte";

  // Code
  let currentUser = null;
  let currentUserIsAuthorized = $state(false);
  let aclAppId = $state(null);

  onMount(async () => {
    currentUser = await window.api.authentication.getCurrentUser.query();
    currentUserIsAuthorized = [
      "localuser@gamepoint.com",
      "darendsen@gamepoint.com",
      "jdevries@gamepoint.com",
      "mvanbuijtene@gamepoint.com",
      "jparlat@gamepoint.com",
      "dzwet@gamepoint.com",
    ].includes(currentUser.username);
  });

  function openNewApp() {
    $ActiveTab = "acl/apps/new";
  }

  function openScopes(appId) {
    $ActiveTab = "acl/scopes";
    aclAppId = appId;
  }
</script>

<main>
  <header class="navbar navbar-expand-md d-print-none">
    <div class="container-xl">
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbar-menu"
        aria-controls="navbar-menu"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div
        class="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pe-0 pe-md-3"
      >
        <a href="/admin"> Admin </a>
      </div>
      <div class="navbar-nav flex-row order-md-last">
        <div class="nav-item dropdown">
          <a
            href="#x"
            class="nav-link d-flex lh-1 text-reset p-0"
            data-bs-toggle="dropdown"
            aria-label="Open user menu"
          >
            <span
              class="avatar avatar-sm"
              style="background-image: url(./static/avatars/002m.jpg)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="icon icon-tabler icons-tabler-outline icon-tabler-menu-2"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M4 6l16 0" />
                <path d="M4 12l16 0" />
                <path d="M4 18l16 0" />
              </svg>
            </span>
            <div class="d-none d-xl-block ps-2">
              <!-- <div>{currentUser.username}</div> -->
              <div class="mt-1 small text-secondary">Admin</div>
            </div>
          </a>

          <div class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
            <a href="/logout" class="dropdown-item">Logout</a>
          </div>
        </div>
      </div>

      <div class="collapse navbar-collapse" id="navbar-menu">
        <div
          class="d-flex flex-column flex-md-row flex-fill align-items-stretch align-items-md-center"
        >
          <ul class="navbar-nav">
            <li class="nav-item active">
              <a class="nav-link" href="/admin">
                <span class="nav-link-title"> Admin </span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/">
                <span class="nav-link-title"> Tools </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>

  <div class="page">
    {#if currentUserIsAuthorized}
      <div class="page-header d-print-none pt-4">
        <div class="container-xl">
          <div class="row g-3 align-items-center">
            <div class="col-md-auto d-print-none">
              <div class="btn-list">
                <button
                  class="btn"
                  class:active={$ActiveTab == "dashboard"}
                  onclick={() => ($ActiveTab = "dashboard")}
                >
                  Dashboard
                </button>
                <button
                  class="btn"
                  class:active={$ActiveTab == "reset2fa"}
                  onclick={() => ($ActiveTab = "reset2fa")}
                >
                  Reset 2FA
                </button>
                <button
                  class="btn"
                  class:active={$ActiveTab == "sessionrules"}
                  onclick={() => ($ActiveTab = "sessionrules")}
                >
                  Session Rules
                </button>
                <button
                  class="btn"
                  class:active={
                    $ActiveTab == "acl/apps" ||
                    $ActiveTab == "acl/scopes" ||
                    $ActiveTab == "acl/apps/new"}
                  onclick={() => ($ActiveTab = "acl/apps")}
                >
                  ACL
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    {/if}

    <div class="page-body">
      {#if !currentUserIsAuthorized}
        <div class="container-xl">
          Uh oh. It seems you don't have access for this page!
        </div>
      {:else if $ActiveTab == "dashboard"}
        <Dashboard view />
      {:else if $ActiveTab == "sessionrules"}
        <Session />
      {:else if $ActiveTab == "reset2fa"}
        <Reset view />
      {:else if $ActiveTab == "acl/apps"}
        <AclApps {openScopes} {openNewApp} />
      {:else if $ActiveTab == "acl/apps/new"}
        <AclNewApp />
      {:else if $ActiveTab == "acl/scopes"}
        <AclScopes {aclAppId} />
      {/if}
    </div>
  </div>

  <!-- TOAST-CONTAINER -->
  <div class="toast-container position-fixed top-0 end-0 p-3 pt-6">
    {#each $toasts as toast (toast.id)}
      <div
        transition:fly={{ duration: 200 }}
        class="toast show"
        class:toast-success={toast.type === "success"}
        class:toast-error={toast.type === "error"}
        class:toast-warning={toast.type === "warning"}
        class:toast-info={toast.type === "info"}
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        data-bs-autohide="false"
        data-bs-toggle="toast"
      >
        <div class="toast-body">
          {toast.message}
        </div>
        {#if toast.dismissible}
          <button
            type="button"
            class="ms-2 btn-close"
            data-bs-dismiss="toast"
            aria-label="Close"
          ></button>
        {/if}
      </div>
    {/each}
  </div>
  <!-- /TOAST-CONTAINER -->
</main>
